import { render } from "./HistorySidebar.vue?vue&type=template&id=d5433dcc&scoped=true"
import script from "./HistorySidebar.vue?vue&type=script&lang=js"
export * from "./HistorySidebar.vue?vue&type=script&lang=js"

import "./HistorySidebar.vue?vue&type=style&index=0&id=d5433dcc&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d5433dcc"]])

export default __exports__